<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.MATCH.SH0W_LIVE"
    :handler="() => $refs.dialog.show()"
  />
  <DialogComponent
    ref="dialog"
    type="fullscreen"
    noInnerPadding
    v-slot="{ transitionStatus }"
  >
    <div class="overflow-auto w-full h-full bg-gray-50">
      <div class="bg-secondary fixed top-0 w-full z-10">
        <div class="mobile-status-padding"></div>
        <div class="px-4 overflow-x-hidden w-full h-24">
          <div class="flex gap-4 items-center h-full">
            <div class="w-8 h-8 min-w-8 flex items-center justify-center">
              <button class="w-full h-full" @click="$refs.dialog.hide()">
                <ColorImg
                  src="/images/icons/arrow-up.svg"
                  class="w-full h-full bg-white -rotate-90 opacity-70"
                  alt="Calendar"
                />
              </button>
            </div>
            <div class="w-full overflow-hidden">
              <div
                class="text-white truncate w-full text-center text-2xl uppercase font-bold"
              >
                En LIVE
              </div>
            </div>
            <div class="w-8 h-8 min-w-8 flex items-center justify-center"></div>
          </div>
        </div>
      </div>
      <div class="py-18"></div>
      <div class="mobile-status-padding"></div>
      <div class="px-5">
        <LiveMatches :loading="transitionStatus == 'opening'" />
      </div>
    </div>
  </DialogComponent>
</template>
